import React from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';

import { Ai2Layout } from '../layout/Ai2Layout';

export const ClinicSettings = () => {
  return (
    <Ai2Layout>
      <div className="offsetNavbar">
        <div className="bgHeading">
          <h1 className="heading1">Clinic Settings</h1>
        </div>
      </div>

      <div className="ui container-fluid">
        <div className="spContainer">
          <h1 className="heading1 mb-4">Set auto replies</h1>
          <form>
            <Form.Group as={Row} controlId="" className="mb-4">
              <Col sm={12} md={7} xl={5}>
                <Form.Label>
                  When a patient requests a mental health appointment
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Default text gois in here"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="" className="mb-4">
              <Col sm={12} md={7} xl={5}>
                <Form.Label>
                  When a patient requests a medication change
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Default text gois in here"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="" className="pt-4">
              <Col sm={12} md={7} xl={5}>
                <Stack direction="horizontal" gap={2}>
                  <button type="" className="btn btnSecondary btn-long btn-sm">
                    Revert to default
                  </button>
                  <button
                    type=""
                    className="btn btnSecondary btn-long btn-sm ms-auto"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btnPrimary btn-long btn-sm"
                  >
                    Save
                  </button>
                </Stack>
              </Col>
            </Form.Group>
          </form>
        </div>
      </div>
    </Ai2Layout>
  );
};
